import { render, staticRenderFns } from "./ReportBooking.vue?vue&type=template&id=a2f78f6c&scoped=true"
import script from "./ReportBooking.vue?vue&type=script&lang=js"
export * from "./ReportBooking.vue?vue&type=script&lang=js"
import style0 from "./ReportBooking.vue?vue&type=style&index=0&id=a2f78f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f78f6c",
  null
  
)

export default component.exports